import React from 'react';
import { makeStyles } from '~/UIKit/Style';
import classNames from 'classnames';
import IllustrationBanner from '../Illustrations/IllustrationBanner';

const useStyles = makeStyles((theme) => ({
  illustrationsContainer: {
    display: 'flex',
    width: '100%',
    height: 150,
    [theme.breakpoints.down('md')]: {
      height: 80,
    },
    [theme.breakpoints.up('md')]: {
      minHeight: 150,
    },
    justifyContent: 'space-between',
    '& > div:nth-child(7)': {
      transform: 'scaleX(-1)',
    },
    '& > div:nth-child(even)': {
      transform: 'translateY(25px)',
    },
  },
}));

interface AppBannerProps {
  count?: number;
  className?: string; // className that will be applied to the wrapper
}

const AppBanner = ({ count, className }: AppBannerProps) => {
  const { classes } = useStyles();
  return (
    <div className={classNames(classes.illustrationsContainer, className)}>
      <IllustrationBanner count={count} />
    </div>
  );
};

export default AppBanner;
